<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
              <label :class="{'txt-right' : true, 'required' : is_required}">Công ty</label>
              <DropdownScrollable cusClass="m-0 cs-width" :loading="loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'"/>
              <input class="input-group input_tmp_validator" id="company" />
            </div>
          </div>
          <div class="f-grid-col">
          </div>
        </div>
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2 accordion-item">
              <label @click="toggleIcon(1)" style="margin:0px;" class="accordion-label">
                <i style="width : 25px;" :class="show_1 == true ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                <span>Thông tin chung</span>
              </label>
              <div class="accordion-content" v-show="show_1 == true">
                <div class="f-grid" style="margin: 0px 10px 0px 10px;">
                  <div class="f-grid-col">
                    <div class="mt-2">
                      <label class="txt-right required">Mã gói công việc</label>
                      <InputText disabled v-model="code" id="code_add" type="text" class="input-text-box cs-input" placeholder="<Hệ thống tạo tự động>"/>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Tên gọi gói công việc</label>
                      <InputText v-model="name" id="name_add" type="text" class="input-text-box cs-input" maxLength="255" placeholder="Nhập (tối đa 255 ký tự)"/>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Nhà máy</label>
                      <DropdownScrollable
                        placeholder="Chọn"
                        :showClear="true"
                        cusClass="m-0 cs-width"
                        defaultLabel="name"
                        :limit="factory_obj.limit"
                        :loading="factory_obj.loading"
                        v-model="selfactory"
                        :options="factory_obj.items"
                        :total="factory_obj.total"
                        @keyup="emitEventFactory"
                        @offset="changeOffsetFactory"
                        @scroll="emitEventFactory"
                      />
                      <input class="input-group input_tmp_validator" id="factory_add" />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Khu vực làm việc</label>
                      <DropdownScrollable
                        placeholder="Chọn"
                        :showClear="true"
                        cusClass="m-0 cs-width"
                        defaultLabel="name"
                        :multiple="false"
                        :limit="areas_obj.limit"
                        :loading="areas_obj.loading"
                        v-model="selareas_sel"
                        :options="areas_obj.items"
                        :total="areas_obj.total"
                        @keyup="emitEventAreas"
                        @offset="changeOffsetAreas"
                        @scroll="emitEventAreas"
                      />
                      <input class="input-group input_tmp_validator" id="areas_add" />
                    </div>
                    <div class="mt-2">
                      <label v-for="(item, index) in selareas" :key="index" class="cus-tags">
                        <span class="cs-tag">
                          {{item.name}}
                        </span>
                        <i class="fas fa-times cs-icon" v-on:click="removeSelareas(index)"></i>
                      </label>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Khu vực</label>
                      <InputText
                        disabled
                        :value="selzone?.name ?? ''"
                        type="text"
                        class="input-text-box cs-input"
                        placeholder=""
                      />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Mô tả công việc</label>
                      <Textarea
                        id="description_add"
                        v-model="description"
                        :autoResize="true"
                        rows="3"
                        maxlength="14000"
                        class="input-text-box"
                        placeholder="Nhập tối đa 14000 ký tự"
                      />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Mức độ rủi ro</label>
                      <Dropdown :showClear="true" v-model="risk_level_sel" :options="risk_levels" optionLabel="label" placeholder="Chọn" class="input-text-box"/>
                    </div>
                    <div v-if="company_type == 'option_1'" class="mt-2">
                      <Checkbox v-model="request_nv" :binary="true" /><span style="font-weight: 700;">Yêu cầu nghiêm ngặt</span>
                    </div>
                  </div>
                  <div class="f-grid-col">
                    <!-- <div class="mt-2">
                      <label class="txt-right required">Thời gian thực hiện từ - đến</label>
                      <div class="p-inputgroup">
                        <Calendar v-model="data_date" selectionMode="range" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" appendTo="body" placeholder="DD/MM/YYYY - DD/MM/YYYY"/>
                      </div>
                      <input class="input_tmp_validator_r" id="data_date_add" />
                    </div> -->
                    <div class="mt-2">
                      <label class="txt-right required">Thời gian thực hiện từ</label>
                      <div class="p-inputgroup">
                        <Calendar v-model="date_start_1" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" appendTo="body" placeholder="DD/MM/YYYY"/>
                      </div>
                      <input class="input_tmp_validator_r" id="data_date_add0" />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Thời gian thực hiện đến</label>
                      <div class="p-inputgroup">
                        <Calendar v-model="date_end_1" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" appendTo="body" placeholder="DD/MM/YYYY"/>
                      </div>
                      <input class="input_tmp_validator_r" id="data_date_add1" />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Giám sát dự án</label>
                      <DropdownScrollable
                        placeholder="Chọn"
                        :showClear="true"
                        cusClass="m-0 cs-width"
                        :multiple="false"
                        :limit="supervisor_obj.limit"
                        :loading="supervisor_obj.loading"
                        v-model="supervisors_sel"
                        :options="supervisor_obj.items"
                        :total="supervisor_obj.total"
                        @keyup="emitEventSupervisor"
                        @scroll="emitEventSupervisor"
                        @offset="changeOffsetSupervisor"
                      />
                      <input class="input_tmp_validator_r" id="supervisors_add" />
                    </div>
                    <div class="mt-2">
                      <label v-for="(item, index) in supervisors" :key="index" class="cus-tags">
                        <span class="cs-tag">
                          {{item.name}}
                        </span>
                        <i class="fas fa-times cs-icon" v-on:click="removeSupervisors(index)"></i>
                      </label>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Nhà thầu</label>
                      <DropdownScrollable
                        placeholder="Chọn"
                        :showClear="true"
                        cusClass="m-0 cs-width"
                        defaultLabel="label"
                        :limit="contractor_obj.limit"
                        :loading="contractor_obj.loading"
                        v-model="selcontractor"
                        :options="contractor_obj.items"
                        :total="contractor_obj.total"
                        @keyup="emitEventContractor"
                        @offset="changeOffsetContractor"
                        @scroll="emitEventContractor"
                        :disabled="mode=='edit'"
                      />
                      <input class="input_tmp_validator_r" id="contractor_add" />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required">Duyệt cấp 1</label>
                      <DropdownScrollable
                        placeholder="Chọn"
                        :showClear="true"
                        cusClass="m-0 cs-width"
                        :limit="users1_obj.limit"
                        :loading="users1_obj.loading"
                        v-model="selusers1"
                        :options="users1_obj.items"
                        :total="users1_obj.total"
                        @keyup="emitEventUsers1"
                        @offset="changeOffsetUsers1"
                        @scroll="emitEventUsers1"
                      />
                      <input class="input_tmp_validator_r" id="selusers1_add" />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">Duyệt cấp 2</label>
                      <DropdownScrollable
                        placeholder="Chọn"
                        :showClear="true"
                        cusClass="m-0 cs-width"
                        :limit="users2_obj.limit"
                        :loading="users2_obj.loading"
                        v-model="selusers2"
                        :options="users2_obj.items"
                        :total="users2_obj.total"
                        @keyup="emitEventUsers2"
                        @offset="changeOffsetUsers2"
                        @scroll="emitEventUsers2"
                      />
                      <input class="input_tmp_validator_r" id="selusers2_add" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2 accordion-item">
              <label @click="toggleIcon(2)" style="margin:0px;" class="accordion-label">
                <i style="width : 25px;" :class="show_2 == true ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                <span>Mối nguy và biện pháp kiểm soát</span>
              </label>
              <div class="accordion-content" v-show="show_2 == true">
                <div class="f-grid" style="margin: 0px 10px 0px 10px;">
                  <div class="f-grid-col">
                    <div class="mt-2">
                      <label class="txt-right required">Những mối nguy liên quan</label>
                      <div class="row ml-0">
                        <div class="p-col-5 pl-0" style="padding:0px">
                          <DropdownScrollable 
                            placeholder="Danh mục mối nguy" 
                            :showClear="true" 
                            cusClass="m-0 cs-width"
                            :multiple="false"
                            :limit="category_obj.limit"
                            :loading="category_obj.loading"
                            v-model="category"
                            :options="category_obj.items"
                            :total="category_obj.total"
                            @keyup="emitEventCategory"
                            @scroll="emitEventCategory"
                            @offset="changeOffsetCategory"
                          />
                        </div>
                        <div class="p-col-7 pr-0" style="padding:0px 0px 0px 5px;">
                          <DropdownScrollable 
                            placeholder="Chọn rủi ro" 
                            :showClear="true" 
                            cusClass="m-0 cs-width"
                            :multiple="false"
                            :limit="danger_obj.limit"
                            :loading="danger_obj.loading"
                            v-model="danger"
                            :options="danger_obj.items"
                            :total="danger_obj.total"
                            @keyup="emitEventDanger"
                            @scroll="emitEventDanger"
                            @offset="changeOffsetDanger"
                          />
                        </div>
                      </div>
                      <input class="input_tmp_validator_r" id="danger_add" />
                    </div>
                    <div class="mt-2">
                      <label v-for="(item, index) in list_danger" :key="index" class="cus-tags">
                        <span class="cs-tag">
                          {{item.name}}
                        </span>
                        <i class="fas fa-times cs-icon" v-on:click="removeDanger(index)"></i>
                      </label>
                    </div>
                  </div>
                  <div class="f-grid-col">
                    <div class="mt-2">
                      <label class="txt-right required">Các biện pháp kiểm soát đề nghị</label>
                      <Textarea
                        id="control_measures_text"
                        v-model="control_measures_text"
                        :autoResize="true"
                        rows="3"
                        class="input-text-box"
                        placeholder="Nhập biện pháp kiểm soát đề nghị"
                      />
                    </div>
                    <div class="mt-2">
                      <label class="txt-right">File đính kèm</label>
                      <div class="cus-text">Dung lượng tối đa: 50 MB</div>
                      <div class="cus-text">Định dạng file: docx, doc, xlsx, xls, pptx, pdf, png, jpg, jpeg.</div>
                      <input class="p-inputtext p-component input-text-box" multiple style="background-color: #EEEEEE;" accept=".docx, .doc, .xlsx, .xls, .pptx, .pdf, .png, .jpg, .jpeg" name="files[]" type="file" @change="onFileSelect"/>
                      <div class="box-images mt-3 input-text-box profile-file-list" v-if="files && files.length > 0">
                        <div class="profile-file-row" v-for="(item, index) in files" :key="index">
                          <a href="#" class="profile-file-link" @click.prevent="viewFile(item)">{{item.name}}</a>
                          <Button icon="pi pi-download" class="p-button-download p-button-link" @click="onFileDownload(index)"/>
                          <Button icon="pi pi-trash" class="p-button-secondary p-button-link text-danger" @click="onFileClear(index)"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2 accordion-item">
              <label @click="toggleIcon(3)" style="margin:0px;" class="accordion-label">
                <i style="width : 25px;" :class="show_3 == true ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                <span>Các thủ tục yêu cầu kiểm soát an toàn & Khóa đào tạo</span>
              </label>
              <div class="accordion-content" v-show="show_3 == true">
                <div class="f-grid" style="margin: 0px 10px 0px 10px;">
                  <div class="f-grid-col">
                    <div class="mt-2">
                      <label class="txt-right required" style="margin-bottom : 0px;">Hồ sơ doanh nghiệp</label><br>
                      <div v-for="(ycc, index) in yc_contractor" :key="index" style="padding-bottom: 2px;">
                        <Checkbox v-model="ycc.check" :binary="true" /><span>{{ycc.name}}</span><br>
                        <div v-if="ycc.check==true && ycc.id==''" style="margin-left: 25px;">
                          <Textarea v-model="ycc.name_other" :autoResize="true" rows="1" class="input-text-box" maxLength="255" placeholder="Nhập (tối đa 255 ký tự)"/>
                        </div>
                      </div>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right" style="margin-bottom : 0px;">Hồ sơ vật tư</label><br>
                      <div v-for="(ycs, index) in yc_supplies" :key="index" style="padding-bottom: 2px;">
                        <Checkbox v-model="ycs.check" :binary="true" /><span>{{ycs.name}}</span><br>
                        <div v-if="ycs.check==true && ycs.id==''" style="margin-left: 25px;">
                          <Textarea v-model="ycs.name_other" :autoResize="true" rows="1" class="input-text-box" maxLength="255" placeholder="Nhập (tối đa 255 ký tự)"/>
                        </div>
                      </div>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right required" style="margin-bottom : 0px;">Khóa đào tạo</label><br>
                      <div class="row ml-0">
                        <DropdownScrollable 
                          placeholder="Chọn" 
                          :showClear="true" 
                          cusClass="m-0 cs-width"
                          :multiple="false"
                          :limit="course_obj.limit"
                          :loading="course_obj.loading"
                          v-model="course"
                          :options="course_obj.items"
                          :total="course_obj.total"
                          @keyup="emitEventCourse"
                          @scroll="emitEventCourse"
                          @offset="changeOffsetCourse"
                        />
                      </div>
                      <input class="input_tmp_validator_r" id="course_add" />
                    </div>
                    <div class="mt-2">
                      <label v-for="(item, index) in list_course" :key="index" class="cus-tags">
                        <span class="cs-tag">
                          {{item.name}}
                        </span>
                        <i class="fas fa-times cs-icon" v-on:click="removeCourse(index)"></i>
                      </label>
                    </div>
                  </div>
                  <div class="f-grid-col">
                    <div class="mt-2">
                      <label class="txt-right" style="margin-bottom : 0px;">Hồ sơ nhân sự</label><br>
                      <div v-for="(ycp, index) in yc_personnel" :key="index" style="padding-bottom: 2px;">
                        <Checkbox v-model="ycp.check" :binary="true" /><span>{{ycp.name}}</span><br>
                        <div v-if="ycp.check==true && ycp.id==''" style="margin-left: 25px;">
                          <Textarea v-model="ycp.name_other" :autoResize="true" rows="1" class="input-text-box" maxLength="255" placeholder="Nhập (tối đa 255 ký tự)"/>
                        </div>
                      </div>
                    </div>
                    <div class="mt-2">
                      <label class="txt-right" style="margin-bottom : 0px;">Hồ sơ thiết bị</label><br>
                      <div v-for="(yce, index) in yc_equipment" :key="index" style="padding-bottom: 2px;">
                        <Checkbox v-model="yce.check" :binary="true" /><span>{{yce.name}}</span><br>
                        <div v-if="yce.check==true && yce.id==''" style="margin-left: 25px;">
                          <Textarea v-model="yce.name_other" :autoResize="true" rows="1" class="input-text-box" maxLength="255" placeholder="Nhập (tối đa 255 ký tự)"/>
                        </div>
                      </div>
                    </div>
                    <div class="mt-2" v-if="company_type == 'option_1'">
                      <label class="txt-right" style="margin-bottom : 0px;">Giấy phép làm việc</label><br>
                      <div class="cus-text">Dung lượng tối đa: 50 MB</div>
                      <div class="cus-text">Định dạng file: docx, doc, xlsx, xls, pptx, pdf, png, jpg, jpeg.</div>
                      <input class="p-inputtext p-component input-text-box" multiple style="background-color: #EEEEEE;" accept=".docx, .doc, .xlsx, .xls, .pptx, .pdf, .png, .jpg, .jpeg" name="files_work_permit[]" type="file" @change="onFileSelectWorkPermit"/>
                      <div class="box-images mt-3 input-text-box profile-file-list" v-if="files_work_permit && files_work_permit.length > 0">
                        <div class="profile-file-row" v-for="(item, index) in files_work_permit" :key="index">
                          <a href="#" class="profile-file-link" @click.prevent="viewFile(item)">{{item.name}}</a>
                          <Button icon="pi pi-download" class="p-button-download p-button-link" @click="onFileDownloadWorkPermit(index)"/>
                          <Button icon="pi pi-trash" class="p-button-secondary p-button-link text-danger" @click="onFileClearWorkPermit(index)"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable_v2.vue';
import ApiRepository from "@/core/ApiRepository";
import moment from "moment-timezone";
export default {
  components:{
    DropdownScrollable
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      show_1 : true,
      show_2 : false,
      show_3 : false,
      filters: {},
      code : "",
      name: "",
      active: false,
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      phone : null,
      is_required : true,
      factory_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      selfactory : null,
      contractor_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      selcontractor : null,
      selzone : null,
      areas_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      selareas : [],
      description : '',
      date_start_1 : null,
      date_end_1 : null,
      data_date : [],
      supervisor_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      supervisors : [],
      users1_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      users2_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      selusers1 : null,
      selusers2 : null,
      list_danger : [
        // {id : "asda",name:"dangaga"},{id : "2323",name:"dangaga"}
      ],
      category_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      category : null,
      danger_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      danger : null,
      control_measures_text : '',
      yc_contractor : [],
      yc_personnel : [],
      yc_supplies : [],
      yc_equipment : [],
      list_course : [],
      edit_id : null,
      is_load : false,
      course : null,
      course_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      selareas_sel : null,
      supervisors_sel : null,
      risk_level_sel: null,
      risk_levels : [
        { label: 'Thấp', value: 'LOW' },
        { label: 'Trung bình', value: 'MEDIUM' },
        { label: 'Cao', value: 'HIGH' },
      ],
      request_nv : false,
      company_type : 'normal',
      files : [],
      filesDeletes : [],
      files_work_permit : [],
      filesDeletesWorkPermit : [],
      maxFiles : 10,
      maxFileSize : 10485760 * 5
    };
  },
  async mounted() {
    // var date_start = '2024-10-01'
    // var date_end = '2024-10-05'
    // this.data_date = [new Date(date_start), new Date(date_end)]
    if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
      var company_type = this.$store.getters?.companyType ?? 'normal'
      this.company = {id: this.$store.getters.company_id, company_type : company_type};
      this.company_type = company_type
    }else{
      await this.getListCompany();
    }
    this.is_load = true
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      console.log("modelmodelmodelmodel==",this.model)
      this.company = this.model.company;
      this.company_type = this.model.company?.company_type ?? 'normal'
      this.code = this.model.code;
      this.active = this.model.active;
      this.name = this.model.name;
      this.description = this.model.description;
      this.selfactory = this.model.factory;
      let request_nv = false
      if(this.model.request_nv == 1){
        request_nv = true
      }
      this.request_nv = request_nv
      if(this.model.date_start && this.model.date_end){
        this.date_start_1 = new Date(this.model.date_start)
        this.date_end_1 = new Date(this.model.date_end)
        // this.data_date = [new Date(this.model.date_start), new Date(this.model.date_end)]
      }
      if(this.model.sra_areas){
        this.selareas = this.model.sra_areas;
      }
      var supervisors = []
      // console.log("this.model.sra_supervisor.length",this.model.sra_supervisor.length)
      if(this.model.sra_supervisor && this.model.sra_supervisor.length > 0){
        for (let i = 0; i < this.model.sra_supervisor.length; i++) {
          const e = this.model.sra_supervisor[i];
          supervisors.push({id : e.uid, fullname : e.fullname , name : e.fullname})
        }
      }
      if(this.model.contractor){
        this.selcontractor = {
          id : this.model.contractor.id,
          name : this.model.contractor.name,
          label : '['+this.model.contractor.code+'] '+this.model.contractor.name
        }
      }
      if(this.model.zone){
        this.selzone = {
          id : this.model.zone?.id ?? this.model.zone_id,
          name : this.model.zone?.name ?? this.model.zone_name ?? ''
        }
      }
      this.supervisors = supervisors
      if(this.model.uid_c1){
        this.selusers1 = {
          id : this.model.uid_c1,
          fullname : this.model.fullname_c1,
          name : this.model.fullname_c1,
        }
      }
      if(this.model.uid_c2){
        this.selusers2 = {
          id : this.model.uid_c2,
          fullname : this.model.fullname_c2,
          name : this.model.fullname_c2,
        }
      }
      this.risk_level_sel = this.model.risk_level ? this.risk_levels.find(item => item.value === this.model.risk_level) : null;
      
      var list_danger = []
      if(this.model.sra_danger && this.model.sra_danger.length > 0){
        for (let i = 0; i < this.model.sra_danger.length; i++) {
          const ee = this.model.sra_danger[i];
          list_danger.push({id : ee.danger.id, name : ee.danger.name})
        }
      }
      var list_course = []
      if(this.model.sra_course && this.model.sra_course.length > 0){
        for (let i = 0; i < this.model.sra_course.length; i++) {
          const el = this.model.sra_course[i];
          list_course.push({id : el.course.id, name : el.course.name})
        }
      }
      this.control_measures_text = this.model.control_measures
      this.list_danger = list_danger;
      this.list_course = list_course;
      this.files = (this.model.file_control_measures ?? []).map(item => ({
        ...item,
        type: 'old_edit'
      }))
      this.filesDeletes = []
      this.files_work_permit = (this.model.file_work_permit ?? []).map(item => ({
        ...item,
        type: 'old_edit'
      }))
      this.filesDeletesWorkPermit = []
      if (this.$route.params.id !== undefined) this.edit_id = this.$route.params.id;
      await this.getListMapYC();
      this.show_2 = true
      this.show_3 = true
      this.getListUsers1();
      this.getListUsers2();
    }
    this.is_load = false
  },
  watch: {
    async "company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company = {id: this.company_id};
      }
    },
    async "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
        this.company = {id: this.company_id};
      }
    },
    async "company"() {
      this.selareas_sel = null
      this.supervisors_sel = null
      this.company_type = this.company?.company_type ?? 'normal'
      if(this.mode == 'add'){
        this.factory_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        this.contractor_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        this.supervisor_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        this.users1_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        },
        this.users2_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        },
        this.category_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        this.selfactory = null
        this.supervisors = []
        this.selcontractor = null
        this.selzone = null
        this.selusers1 = null
        this.selusers2 = null
        this.category = null
        this.danger = null
        this.list_danger = []
        this.yc_contractor = []
        this.yc_personnel = []
        this.yc_supplies = []
        this.yc_equipment = []
        this.getListMapYC();
        await this.getListContractor();
      }
      await this.getListFactory();
      await this.getListSupervisor();
      await this.getListCategory();
      await this.getListDanger();
      this.getListCourse();
    },
    async "selfactory"(value, oldValue) {
      if(this.is_load == true){
        return
      }
      if(this.$commonFuction.isEmptyObject(value)){
        this.selzone = null
      }else{
        const nextZone = value.zone ?? ((value.zone_id || value.zone_name) ? {
          id : value.zone_id ?? value.zone?.id ?? null,
          name : value.zone?.name ?? value.zone_name ?? ''
        } : null)
        if ((oldValue?.id ?? null) !== (value?.id ?? null) || this.selzone?.name !== (nextZone?.name ?? null)) {
          this.selzone = nextZone
        }
      }
      if(this.mode == 'add'){
        this.selareas = []
        this.areas_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
      }else if(this.is_load== false){
        this.selareas = []
        this.areas_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
      }
      await this.getListAreas();
    },
    async "category"() {
      // if(this.mode == 'add'){
      //   this.danger = null
      // }
      this.danger = null
      this.danger_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      await this.getListDanger();
    },
    async "danger"() {
      if(this.$commonFuction.isEmptyObject(this.danger)){
        return
      }else{
        var check_exist = false;
        for (let i = 0; i < this.list_danger.length; i++) {
          if(this.list_danger[i].id == this.danger.id){
            check_exist = true;
            break;
          }
        }
        if(check_exist == false){
          this.list_danger.push(this.danger)
        }
        this.danger = null
      }
    },
    async "course"() {
      if(this.$commonFuction.isEmptyObject(this.course)){
        return
      }else{
        var check_exist = false;
        for (let i = 0; i < this.list_course.length; i++) {
          if(this.list_course[i].id == this.course.id){
            check_exist = true;
            break;
          }
        }
        if(check_exist == false){
          this.list_course.push(this.course)
        }
        this.course = null
      }
    },
    async "selareas_sel"() {
      if(this.$commonFuction.isEmptyObject(this.selareas_sel)){
        return
      }else{
        var check_exist = false;
        for (let i = 0; i < this.selareas.length; i++) {
          if(this.selareas[i].id == this.selareas_sel.id){
            check_exist = true;
            break;
          }
        }
        if(check_exist == false){
          this.selareas.push(this.selareas_sel)
        }
        this.selareas_sel = null
      }
    },
    async "supervisors_sel"() {
      if(this.$commonFuction.isEmptyObject(this.supervisors_sel)){
        return
      }else{
        var check_exist = false;
        for (let i = 0; i < this.supervisors.length; i++) {
          if(this.supervisors[i].id == this.supervisors_sel.id){
            check_exist = true;
            break;
          }
        }
        if(check_exist == false){
          this.supervisors.push(this.supervisors_sel)
        }
        this.supervisors_sel = null
      }
    },
  },
  methods: {
    backToList() {
      this.$emit("back");
    },
    async emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.offset = value;
      // await this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.items.push(...res.data.data.company);
          } else {
            this.items = res.data.data.company;
          }
          this.total = res.data.data.total;
          this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async validateData() {
      this.validationErrors = {};
      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Công ty không được để trống!");
        } else {
          company_add.setCustomValidity("");
        }
      }
      let name_add = document.getElementById("name_add");
      if ( this.name == undefined || this.name == null || this.name == "") {
        name_add.setCustomValidity("Tên gọi gói công việc không được để trống!");
      } else if (this.name.length > 255) {
        name_add.setCustomValidity("Tên gọi gói công việc không được quá 255 ký tự!");
      } else {
        name_add.setCustomValidity("");
      }
      let factory_add = document.getElementById("factory_add");
      if (
        this.$commonFuction.isEmptyObject(this.selfactory) ||
        this.$commonFuction.isEmpty(this.selfactory)
      ) {
        factory_add.setCustomValidity("Vui lòng chọn nhà máy!");
      } else {
        factory_add.setCustomValidity("");
      }
      let areas_add = document.getElementById("areas_add");
      if (
        this.$commonFuction.isEmptyObject(this.selareas) ||
        this.$commonFuction.isEmpty(this.selareas)
      ) {
        areas_add.setCustomValidity("Vui lòng chọn khu vực làm việc!");
      } else {
        areas_add.setCustomValidity("");
      }
      let description_add = document.getElementById("description_add");
      if ( this.$commonFuction.isEmpty(this.description)) {
        description_add.setCustomValidity("Vui lòng nhập mô tả công việc!");
      } else {
        description_add.setCustomValidity("");
      }
      // let data_date_add = document.getElementById("data_date_add");
      // if(this.data_date && this.data_date.length == 2){
      //   if(this.data_date[0] && this.data_date[1]){
      //     data_date_add.setCustomValidity("");
      //   }else{
      //     data_date_add.setCustomValidity("Vui lòng chọn thời gian thực hiện!");
      //   }
      // }else{
      //   data_date_add.setCustomValidity("Vui lòng chọn thời gian thực hiện!");
      // }

      let data_date_add0 = document.getElementById("data_date_add0");
      if ( this.$commonFuction.isEmpty(this.date_start_1)) {
        data_date_add0.setCustomValidity("Vui lòng chọn thời gian thực hiện từ!");
      } else {
        data_date_add0.setCustomValidity("");
      }
      let data_date_add1 = document.getElementById("data_date_add1");
      if ( this.$commonFuction.isEmpty(this.date_end_1)) {
        data_date_add1.setCustomValidity("Vui lòng chọn thời gian thực hiện đến!");
      } else {
        if (this.date_start_1 > this.date_end_1) {
          data_date_add1.setCustomValidity("Thời gian thực hiện đến phải lớn hơn thời gian thực hiện từ!");
        } else {
          data_date_add1.setCustomValidity("");
        }
      }
      let supervisors_add = document.getElementById("supervisors_add");
      if (
        this.$commonFuction.isEmptyObject(this.supervisors) ||
        this.$commonFuction.isEmpty(this.supervisors)
      ) {
        supervisors_add.setCustomValidity("Vui lòng chọn giám sát!");
      } else {
        supervisors_add.setCustomValidity("");
      }
      let contractor_add = document.getElementById("contractor_add");
      if (
        this.$commonFuction.isEmptyObject(this.selcontractor) ||
        this.$commonFuction.isEmpty(this.selcontractor)
      ) {
        contractor_add.setCustomValidity("Vui lòng chọn nhà thầu!");
      } else {
        contractor_add.setCustomValidity("");
      }
      let selusers1_add = document.getElementById("selusers1_add");
      if (
        this.$commonFuction.isEmptyObject(this.selusers1) ||
        this.$commonFuction.isEmpty(this.selusers1)
      ) {
        selusers1_add.setCustomValidity("Vui lòng chọn người duyệt cấp 1!");
      } else {
        selusers1_add.setCustomValidity("");
      }
      let danger_add = document.getElementById("danger_add");
      if(this.list_danger.length > 0){
        danger_add.setCustomValidity("");
      }else{
        danger_add.setCustomValidity("Vui lòng chọn mối nguy liên quan!");
      }
      let control_measures_text = document.getElementById("control_measures_text");
      if ( this.$commonFuction.isEmpty(this.control_measures_text)) {
        control_measures_text.setCustomValidity("Vui lòng nhập biện pháp kiểm soát!");
      } else {
        control_measures_text.setCustomValidity("");
      }
      let course_add = document.getElementById("course_add");
      if(this.list_course.length > 0){
        course_add.setCustomValidity("");
      }else{
        course_add.setCustomValidity("Vui lòng chọn khóa đào tạo!");
      }
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async showcheck(){
      this.show_1 = true;
      this.show_2 = true;
      this.show_3 = true;
    },
    async saveData() {
      // this.$commonFuction.is_loading(true);
      await this.showcheck()
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if(this.yc_contractor.length > 0){
        var check_sel = false;
        for (let i = 0; i < this.yc_contractor.length; i++) {
          const e = this.yc_contractor[i];
          if(e.check == true){
            check_sel = true;
            break;
          }
        }
        if(check_sel == false){
          alert("Vui lòng chọn tối thiểu một hồ sơ doanh nghiệp!");
          this.$commonFuction.is_loading(false);
          return;
        }
      }
      // var date_start = moment(this.data_date[0]).format("YYYY-MM-DD")
      // var date_end = moment(this.data_date[1]).format("YYYY-MM-DD")
      var date_start = moment(this.date_start_1).format("YYYY-MM-DD")
      var date_end = moment(this.date_end_1).format("YYYY-MM-DD")
      var request_nv = 0;
      // console.log("this.request_nv",this.request_nv)
      if(this.request_nv){
        request_nv = 1
      }
      var params = {
        name: this.name,
        // active: this.active,
        company: this.company,
        factory: this.selfactory,//nhà máy
        areas: this.selareas,//khu vực làm việc
        description : this.description,
        date_start : date_start,//ngày
        date_end : date_end,//ngày
        supervisors : this.supervisors,//giám sát
        contractor : this.selcontractor,//nhà thầu
        zone : this.selzone,//zone
        users1 : this.selusers1,//duyệt 1
        users2 : this.selusers2,//duyệt 2
        list_danger : this.list_danger,
        control_measures_text : this.control_measures_text,
        yc_contractor : this.yc_contractor,
        yc_personnel : this.yc_personnel,
        yc_supplies : this.yc_supplies,
        yc_equipment : this.yc_equipment,
        list_course : this.list_course,
        risk_level_sel: this.risk_level_sel ?? null,
        request_nv : request_nv,
        files : this.files,
        filesDeletes : this.filesDeletes,
        files_work_permit : this.files_work_permit,
        filesDeletesWorkPermit : this.filesDeletesWorkPermit
      };
      console.log("saveData", params);
      // this.$commonFuction.is_loading(false);
      this.$emit("save", params);
      
    },
    toggleIcon(key){
      if(key == 1){
        this.show_1 = !this.show_1
      }else if(key == 2){
        this.show_2 = !this.show_2
      }else if(key == 3){
        this.show_3 = !this.show_3
      }
    },
    emitEventFactory(keyword) {
      // console.log(keyword);
      this.$delete(this.factory_obj.filters, 'name');
      if (keyword) {
        this.factory_obj.filters.name = keyword;
      }
      this.getListFactory();
    },
    changeOffsetFactory(value) {
      this.factory_obj.offset = value;
    },
    async getListFactory() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.factory_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.factory_obj.loading = true;
        await ApiRepository.post("/_api/factory/options", {filters: this.factory_obj.filters, limit: this.factory_obj.limit, offset: this.factory_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.factory_obj.offset > 0 ) {
            this.factory_obj.items.push(...res.data.data.factory);
          } else{
            this.factory_obj.items = res.data.data.factory;
          }
          this.factory_obj.total = res.data.data.count;
          this.factory_obj.loading = false;
        }).catch((err) => {
          console.log(err);
          this.factory_obj.loading = false;
        })
      }
    },
    emitEventContractor(keyword) {
      // console.log(keyword);
      this.$delete(this.contractor_obj.filters, 'filter_txt');
      if (keyword) {
        this.contractor_obj.filters.filter_txt = keyword;
      }
      this.getListContractor();
    },
    changeOffsetContractor(value) {
      this.contractor_obj.offset = value;
    },
    async getListContractor() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.contractor = null,
        this.contractor_obj = {
          offset: 0,
          filters: {},
          limit: 20,
          items: [],
          total: 0,
          loading: false
        }
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.contractor_obj.loading = true;
        await ApiRepository.post("/_api/contractor/options_with_zone", {filters: this.contractor_obj.filters, limit: this.contractor_obj.limit, offset: this.contractor_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            if (this.contractor_obj.offset > 0 ) {
              this.contractor_obj.items.push(...res.data.data.contractor);
            } else{
              this.contractor_obj.items = res.data.data.contractor;
            }
            this.contractor_obj.total = res.data.data.count;
            this.contractor_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.contractor_obj.loading = false;
        })
      }
    },
    emitEventAreas(keyword) {
      // console.log(keyword);
      this.$delete(this.areas_obj.filters, 'name');
      if (keyword) {
        this.areas_obj.filters.name = keyword;
      }
      this.getListAreas();
    },
    changeOffsetAreas(value) {
      this.areas_obj.offset = value;
    },
    async getListAreas() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var factory_id = this.selfactory?.id ?? null;
      if(!factory_id){
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.areas_obj.loading = true;
        await ApiRepository.post("/_api/area/options", {filters: this.areas_obj.filters, limit: this.areas_obj.limit, offset: this.areas_obj.offset, company_id: this.company.id ,factory_id : factory_id}, {headers}).then((res) => {
            if (this.areas_obj.offset > 0 ) {
              this.areas_obj.items.push(...res.data.data.area);
            } else{
              this.areas_obj.items = res.data.data.area;
            }
            this.areas_obj.total = res.data.data.count;
            this.areas_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.areas_obj.loading = false;
        })
      }
    },
    emitEventSupervisor(keyword) {
      // console.log(keyword);
      this.$delete(this.supervisor_obj.filters, 'name');
      if (keyword) {
        this.supervisor_obj.filters.name = keyword;
      }
      this.getListSupervisor();
    },
    changeOffsetSupervisor(value) {
      this.supervisor_obj.offset = value;
    },
    async getListSupervisor() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.supervisor_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.supervisor_obj.filters, limit: this.supervisor_obj.limit, offset: this.supervisor_obj.offset, company_id: this.company.id, type_company : 'internal'}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.supervisor_obj.offset > 0 ) {
              this.supervisor_obj.items.push(...tmp);
            } else{
              this.supervisor_obj.items = tmp;
            }
            
            this.supervisor_obj.total = res.data.data.count;
            this.supervisor_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.supervisor_obj.loading = false;
        })
      }
    },
    emitEventUsers1(keyword) {
      // console.log(keyword);
      this.$delete(this.users1_obj.filters, 'name');
      if (keyword) {
        this.users1_obj.filters.name = keyword;
      }
      this.getListUsers1();
    },
    changeOffsetUsers1(value) {
      this.users1_obj.offset = value;
    },
    async getListUsers1() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.users1_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.users1_obj.filters, limit: this.users1_obj.limit, offset: this.users1_obj.offset, company_id: this.company.id, type_company : 'internal', approve_sra : true}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.users1_obj.offset > 0 ) {
              this.users1_obj.items.push(...tmp);
            } else{
              this.users1_obj.items = tmp;
            }
            
            this.users1_obj.total = res.data.data.count;
            this.users1_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.users1_obj.loading = false;
        })
      }
    },
    emitEventUsers2(keyword) {
      // console.log(keyword);
      this.$delete(this.users2_obj.filters, 'name');
      if (keyword) {
        this.users2_obj.filters.name = keyword;
      }
      this.getListUsers2();
    },
    changeOffsetUsers2(value) {
      this.users2_obj.offset = value;
    },
    async getListUsers2() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.users2_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.users2_obj.filters, limit: this.users2_obj.limit, offset: this.users2_obj.offset, company_id: this.company.id, type_company : 'internal', approve_sra : true}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.users2_obj.offset > 0 ) {
              this.users2_obj.items.push(...tmp);
            } else{
              this.users2_obj.items = tmp;
            }
            
            this.users2_obj.total = res.data.data.count;
            this.users2_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.users2_obj.loading = false;
        })
      }
    },
    async removeDanger(index){
      this.list_danger.splice(index, 1)
    },
    async removeCourse(index){
      this.list_course.splice(index, 1)
    },
    emitEventCategory(keyword) {
      // console.log(keyword);
      this.$delete(this.category_obj.filters, 'name');
      if (keyword) {
        this.category_obj.filters.name = keyword;
      }
      this.getListCategory();
    },
    changeOffsetCategory(value) {
      this.category_obj.offset = value;
    },
    async getListCategory() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.category_obj.loading = true;
        await ApiRepository.post("/_api/category/options", {filters: this.category_obj.filters, limit: this.category_obj.limit, offset: this.category_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            if (this.category_obj.offset > 0 ) {
              this.category_obj.items.push(...tmp);
            } else{
              this.category_obj.items = tmp;
            }
            this.category_obj.total = res.data.data.total;
            this.category_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.category_obj.loading = false;
        })
      }
    },
    emitEventDanger(keyword) {
      // console.log(keyword);
      this.$delete(this.danger_obj.filters, 'name');
      if (keyword) {
        this.danger_obj.filters.name = keyword;
      }
      this.getListDanger();
    },
    changeOffsetDanger(value) {
      this.danger_obj.offset = value;
    },
    async getListDanger() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      if(!this.$commonFuction.isEmptyObject(this.category)) {
        this.danger_obj.filters.category_id = this.category.id
      }
      this.danger_obj.filters.active = true
      this.danger_obj.filters.status = 'APPROVED'
      this.danger_obj.filters.get_other = false
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.danger_obj.loading = true;
        await ApiRepository.post("/_api/danger/options", {filters: this.danger_obj.filters, limit: this.danger_obj.limit, offset: this.danger_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            if (this.danger_obj.offset > 0 ) {
              this.danger_obj.items.push(...tmp);
            } else{
              this.danger_obj.items= tmp;
            }
            this.danger_obj.total = res.data.data.total;
            this.danger_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.danger_obj.loading = false;
        })
      }
    },
    emitEventCourse(keyword) {
      // console.log(keyword);
      this.$delete(this.course_obj.filters, 'name');
      if (keyword) {
        this.course_obj.filters.name = keyword;
      }
      this.getListCourse();
    },
    changeOffsetCourse(value) {
      this.course_obj.offset = value;
    },
    async getListCourse() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.course_obj.loading = true;
        await ApiRepository.post("/_api/course/options", {filters: this.course_obj.filters, limit: this.course_obj.limit, offset: this.course_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.course
            if (this.course_obj.offset > 0 ) {
              this.course_obj.items.push(...tmp);
            } else{
              this.course_obj.items= tmp;
            }
            this.course_obj.total = res.data.data.total;
            this.course_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.course_obj.loading = false;
        })
      }
    },
    async getListMapYC(){
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        }
        await ApiRepository.post("/_api/document_files/map_type", {company_id: this.company.id , object_id : this.edit_id}, {headers}).then((res) => {
          var tmp = res.data?.data
          console.log("data===",tmp)
          this.yc_contractor = tmp.contractor ?? []
          this.yc_personnel = tmp.personnel ?? []
          this.yc_equipment = tmp.equipment ?? []
          this.yc_supplies = tmp.supplies ?? []
        }).catch((err) => {
          console.log(err);
        })
      }
    },
    async removeSelareas(index){
      this.selareas.splice(index, 1)
    },
    async removeSupervisors(index){
      this.supervisors.splice(index, 1)
    },
    async viewFile(file) {
      const fileUrl = file ? (file.url || file.objectURL) : null
      if (!fileUrl) return

      const fileName = file.name || fileUrl.split("?")[0].split("/").pop() || ""
      const extension = fileName.toLowerCase().split(".").pop()
      const imageMimeTypes = {
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        png: "image/png",
        gif: "image/gif",
        webp: "image/webp",
        bmp: "image/bmp",
        svg: "image/svg+xml",
        tif: "image/tiff",
        tiff: "image/tiff",
      }
      const isPdf = extension === "pdf"
      const isImage = Object.prototype.hasOwnProperty.call(imageMimeTypes, extension)

      if (!isPdf && !isImage) {
        window.open(fileUrl, "_blank", "noopener,noreferrer")
        return
      }

      const previewWindow = window.open("", "_blank")
      if (!previewWindow) {
        alert("Vui lòng cho phép trình duyệt mở cửa sổ mới để xem file.")
        return
      }

      previewWindow.opener = null

      try {
        const response = await fetch(fileUrl)
        if (!response.ok) {
          throw new Error(`Không thể tải file (${response.status})`)
        }

        const blob = await response.blob()
        const previewMimeType = isPdf ? "application/pdf" : imageMimeTypes[extension]
        const previewBlob = blob.type === previewMimeType
          ? blob
          : new Blob([blob], { type: previewMimeType })
        const blobUrl = URL.createObjectURL(previewBlob)

        previewWindow.location.href = blobUrl
        const cleanupInterval = window.setInterval(() => {
          if (previewWindow.closed) {
            window.clearInterval(cleanupInterval)
            URL.revokeObjectURL(blobUrl)
          }
        }, 5 * 1000)
      } catch (e) {
        previewWindow.close()
        console.error("Lỗi xem file:", e)
        alert("Không thể mở file. Máy chủ lưu file có thể chưa cho phép truy cập CORS.")
      }
    },
    async onFileDownload(index) {
      let file = this.files[index]
      window.open(file.url ?? file.objectURL)
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files
      if (files.length > 0) {
        if (files.length > this.maxFiles) {
          event.target.value = ""
          alert("Chỉ được upload tối đa 10 file")
          return
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf", "xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF", "XLS",
          "png", "jpg", "jpeg", "PNG", "JPG", "JPEG",
        ]
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = ""
            alert("Vui lòng upload file có định dạng là: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg.")
            return
          }
        }
        if (files.length + this.files.length > this.maxFiles) {
          event.target.value = ""
          alert("Số lượng tối đa là " + this.maxFiles + " files")
          return
        } else {
          var arrTemp = [],
            arrFiles = []
          for (let file of files) {
            if (file.size <= this.maxFileSize) {
              file.source = file
              file.objectURL = window.URL.createObjectURL(file)
              arrTemp.push(file)
            } else {
              arrFiles.push(file)
            }
          }
          if (arrFiles.length > 0) {
            event.target.value = ""
            alert("File của bạn đã quá dung lượng 50MB")
            return
          } else {
            this.files = this.files.concat.apply(this.files, arrTemp)
          }
        }
      }
      event.target.value = ""
      return
    },
    onFileClear(index) {
      var file = this.files[index]
      if (file && file.type === 'old_edit' && file.id) {
        this.filesDeletes.push(file.id)
      }
      this.files.splice(index, 1)
    },
    async onFileDownloadWorkPermit(index) {
      let file = this.files_work_permit[index]
      window.open(file.url ?? file.objectURL)
    },
    async onFileSelectWorkPermit(event) {
      let files = event.target.files || event.dataTransfer.files
      if (files.length > 0) {
        if (files.length > this.maxFiles) {
          event.target.value = ""
          alert("Chỉ được upload tối đa 10 file")
          return
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf", "xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF", "XLS",
          "png", "jpg", "jpeg", "PNG", "JPG", "JPEG",
        ]
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = ""
            alert("Vui lòng upload file có định dạng là: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg.")
            return
          }
        }
        if (files.length + this.files_work_permit.length > this.maxFiles) {
          event.target.value = ""
          alert("Số lượng tối đa là " + this.maxFiles + " files")
          return
        } else {
          var arrTemp = [],
            arrFiles = []
          for (let file of files) {
            if (file.size <= this.maxFileSize) {
              file.source = file
              file.objectURL = window.URL.createObjectURL(file)
              arrTemp.push(file)
            } else {
              arrFiles.push(file)
            }
          }
          if (arrFiles.length > 0) {
            event.target.value = ""
            alert("File của bạn đã quá dung lượng 50MB")
            return
          } else {
            this.files_work_permit = this.files_work_permit.concat.apply(this.files_work_permit, arrTemp)
          }
        }
      }
      event.target.value = ""
      return
    },
    onFileClearWorkPermit(index) {
      var file = this.files_work_permit[index]
      if (file && file.type === 'old_edit' && file.id) {
        this.filesDeletesWorkPermit.push(file.id)
      }
      this.files_work_permit.splice(index, 1)
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
.f-grid {
  display: flex;
  justify-content: space-between;
  margin-left: -1rem;
  flex-flow: row wrap;
}
.f-grid-col {
  flex: 1 0;
  /* background-color: #EEEEEE; */
  padding: 0rem 1rem 0rem 1rem;
  border-radius: 5px;
}
#customers {
  border-collapse: collapse;
  width: 100%;
}
.cs-width {
  width : 100% !important;
}
.cs-input {
  width : 100%;
  /* max-width: 400px !important; */
}
.title-css { 
  font-weight: bold;
}
.drop-cus {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
}
.accordion-item {
  border: 1px solid #ddd;
  border-radius: 5px;
}
.accordion-label {
  display: block;
  padding: 8px;
  background-color: #DFE2E6;
  /* font-size: 15px; */
  font-weight: bold;
  cursor: pointer;
}
.accordion-content {
  margin-bottom: 10px;
}
.cus-tags{
  border-radius: 10px;
  padding: 8px;
  margin-right: 8px;
  background-color:#F2F3F7;
}
.cs-tag {
  padding: 10px 12px 10px 0px;
  font-weight: normal;
}
.cs-icon {
  color : #666666;
  padding-right: 4px;
  cursor: pointer;
}
.cs-icon-right {
  cursor: pointer;
}
.cs-text-right {
  color : #666666;
  float: right;
}
.input_tmp_validator_r {
  display : block;
  width: 0px !important;
  height: 0px !important;
  background-color: #ffffff;
  border: unset;
  outline: unset;
  left: 1em;
}
.cus-text {
  color: #666666;
  font-size: 12px;
  margin-top: 4px;
}
.box-images {
  margin-top: 10px;
  position: relative;
}
.profile-file-list {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.profile-file-row {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 4px;
}
.profile-file-link {
  display: block;
  max-width: 100%;
  color: #0086C4;
  text-decoration: underline;
  overflow-wrap: anywhere;
  cursor: pointer;
}
.box-images .file-name {
  flex: 1 0;
  word-break: break-all;
}
</style>
